module.exports = __webpack_public_path__ + "static/media/bubble-msg-02-eng.48778e03.png";